export class AccountsCard {
  constructor(
    public banks: number,
    public accounts: number,
    public movements: number
  ) {}
}
